import { useEffect } from 'react';

import { useFeatureFlag } from '@order/LaunchDarkly';

import { addAwsWafScript } from '../../utils';

export const useAwsWafScript = () => {
  const isEnabled = useFeatureFlag('CELS-5071-aws-waf-enabled');

  useEffect(() => {
    if (isEnabled) addAwsWafScript();
  }, [isEnabled]);
};
